import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { ProjectStatusIconComponent } from './project-status-icon.component';
import { StatusIconBaseModule } from '../status-icon-base';

@NgModule({
  declarations: [ ProjectStatusIconComponent ],
  imports: [ CommonModule, MatTooltipModule, StatusIconBaseModule ],
  exports: [ ProjectStatusIconComponent ]
})
export class ProjectStatusIconModule { }
